import { render, staticRenderFns } from "./ServiceButtons.vue?vue&type=template&id=3b959a48"
import script from "./ServiceButtons.vue?vue&type=script&lang=js"
export * from "./ServiceButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports